function _classPrivateFieldLooseBase(receiver, privateKey) { if (!Object.prototype.hasOwnProperty.call(receiver, privateKey)) { throw new TypeError("attempted to use private field on non-instance"); } return receiver; }

var id = 0;

function _classPrivateFieldLooseKey(name) { return "__private_" + id++ + "_" + name; }

const BasePlugin = require('@uppy/core/lib/BasePlugin');
/**
 * Add a `results` key to the upload result data, containing all Transloadit Assembly results.
 */


var _afterUpload = /*#__PURE__*/_classPrivateFieldLooseKey("afterUpload");

class TransloaditResultsPlugin extends BasePlugin {
  constructor(uppy, opts) {
    super(uppy, opts);
    Object.defineProperty(this, _afterUpload, {
      writable: true,
      value: (fileIDs, uploadID) => {
        const {
          currentUploads
        } = this.uppy.getState();
        const {
          result
        } = currentUploads[uploadID];
        const assemblies = Array.isArray(result == null ? void 0 : result.transloadit) ? result.transloadit : []; // Merge the assembly.results[*] arrays and add `stepName` and
        // `assemblyId` properties.

        const assemblyResults = [];
        assemblies.forEach(assembly => {
          Object.keys(assembly.results).forEach(stepName => {
            const results = assembly.results[stepName];
            results.forEach(result => {
              assemblyResults.push({ ...result,
                assemblyId: assembly.assembly_id,
                stepName
              });
            });
          });
        });
        this.uppy.addResultData(uploadID, {
          results: assemblyResults
        });
      }
    });
    this.type = 'modifier';
    this.id = this.opts.id || 'TransloaditResultsPlugin';
  }

  install() {
    this.uppy.addPostProcessor(_classPrivateFieldLooseBase(this, _afterUpload)[_afterUpload]);
  }

}

module.exports = TransloaditResultsPlugin;